exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RateVcDemo h4[data-v-3281ced0]{color:#066}.RateVcDemo .demoItem[data-v-3281ced0]{padding:10px 0;border-bottom:1px dotted #999}.RateVcDemo .demoText[data-v-3281ced0]{margin:15px 10px 5px}", ""]);

// exports
